import {skeletonGet} from './skeleton/skeletonGet';

const snapshotMonitorEndpoint = 'sm'
const snapshotPlayerEndpoint = 'sp'

export const GetSnapshotMonitorCall = (filters: Record<string, any>): Promise<any> => {
    const url = `monitor` + (filters ? '?' + new URLSearchParams(filters).toString() : '');
    return skeletonGet(url, snapshotMonitorEndpoint);
};

export const GetSnapshotMonitorByBookmakerCall = (bookmakerId: number): Promise<any> => {
    return skeletonGet(`monitor/bookmaker/${bookmakerId}`, snapshotMonitorEndpoint);
};


export const GetSnapshotPlayersCall = (): Promise<any> => {
    return skeletonGet('player', snapshotPlayerEndpoint);
};
